import { isTestKeysBackend } from '@/session';

// confirmRedirect is Stripe's confirm redirect behavior. Production always uses
// if_required. For testing the payment return locally, setting
// window.__ezsmForceConfirmRedirect = true forces a real top-level redirect,
// only in a Vite dev build against a test-keys backend; the production bundle
// has no switch (import.meta.env.DEV is false).
export function confirmRedirect(): 'always' | 'if_required' {
  if (!import.meta.env.DEV) {
    return 'if_required';
  }
  const forced = (window as { __ezsmForceConfirmRedirect?: boolean }).__ezsmForceConfirmRedirect === true;
  if (forced && isTestKeysBackend()) {
    return 'always';
  }
  return 'if_required';
}
